var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "Subheader",
                {
                  attrs: {
                    search: "guidelines",
                    title: _vm.$t("AnalyteGuidelinesManagement.tableName"),
                  },
                  model: {
                    value: _vm.search,
                    callback: function ($$v) {
                      _vm.search = $$v
                    },
                    expression: "search",
                  },
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success", dark: "" },
                      on: {
                        click: function ($event) {
                          return _vm.clickAddGuideline()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("add")]),
                      _vm._v(
                        _vm._s(_vm.$t("Button.AddToGuideline")) + "\n        "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                {
                  staticClass: "align-center",
                  staticStyle: { display: "flex" },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "primary" } },
                    [_vm._v("info")]
                  ),
                  _vm._v(
                    "\n        The guideline standards that this analyte has been used in.\n      "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _vm.allMismatchedUnitGroup.length
                ? _c(
                    "v-alert",
                    {
                      staticClass: "ma-0",
                      attrs: {
                        value: true,
                        color: "warning lighten-2",
                        icon: "warning",
                        outline: "",
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "primary--text py-2" },
                        [
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _c("span", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.allMismatchedUnitGroup.length == 1
                                      ? _vm.$t(
                                          "AnalyteGuidelinesManagement.singleMismatchedUnitGroup"
                                        )
                                      : _vm.$t(
                                          "AnalyteGuidelinesManagement.multipleMismatchedUnitGroups"
                                        )
                                  ) +
                                  "\n            "
                              ),
                            ]),
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _vm._l(_vm.allMismatchedUnitGroup, function (i) {
                            return _c("span", { key: i.Guideline }, [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("Guideline: "),
                              ]),
                              _vm._v(
                                _vm._s(i.Guideline) +
                                  " " +
                                  _vm._s(i.GuidelineAnalyteName) +
                                  " \n            "
                              ),
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("Guideline Unit Group: "),
                              ]),
                              _vm._v(_vm._s(i.UnitGroup)),
                              _c("br"),
                            ])
                          }),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.analyteGuidelines,
                  "hide-actions": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c("tr", { class: _vm.getRowClass(props.item) }, [
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "tenantGuidelinesDetail",
                                      params: {
                                        name: props.item.GuidelineName,
                                      },
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(props.item.GuidelineName))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item.AnalyteNameInGuideline)),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item.ValueType)),
                          ]),
                          _vm._v(" "),
                          _c("td", {
                            staticClass: "text-xs-left",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.getGuidelineValue(props.item)
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item.Unit)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-right" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { small: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.clickDeleteGuideline(
                                        props.item
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-1",
                                      attrs: { color: "error" },
                                    },
                                    [_vm._v("delete_forever")]
                                  ),
                                  _vm._v(
                                    _vm._s(_vm.$t("Button.Remove")) +
                                      "\n              "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800px" },
          model: {
            value: _vm.addDialog,
            callback: function ($$v) {
              _vm.addDialog = $$v
            },
            expression: "addDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dense: "", dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [_vm._v(_vm._s(_vm.titleInfo))]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          _vm.addDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "form",
                  staticStyle: { width: "100%" },
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function ($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      !_vm.selectGuidelines.length ||
                      !_vm.analyteData.ApplicableUnitGroupId
                        ? _c(
                            "v-alert",
                            {
                              attrs: { outline: "", type: "warning" },
                              model: {
                                value: _vm.alertModel,
                                callback: function ($$v) {
                                  _vm.alertModel = $$v
                                },
                                expression: "alertModel",
                              },
                            },
                            [_vm._v(_vm._s(_vm.alertMsg))]
                          )
                        : _c(
                            "div",
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.selectGuidelines,
                                  label: _vm.$t(
                                    "AnalyteGuidelinesManagement.dialogInput1"
                                  ),
                                  "item-text": "GuidelineName",
                                  "return-object": "",
                                  rules: _vm.guidelineRule,
                                  "persistent-hint": "",
                                  hint: _vm.guidelineHint,
                                },
                                on: { change: _vm.changeGuideline },
                                model: {
                                  value: _vm.newGuideline.guideline,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newGuideline, "guideline", $$v)
                                  },
                                  expression: "newGuideline.guideline",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.selectAnalyte,
                                  label: _vm.$t(
                                    "AnalyteGuidelinesManagement.dialogInput2"
                                  ),
                                  "item-text": "AnalyteNameInGuideline",
                                  "return-object": "",
                                  rules: _vm.standardRule,
                                },
                                model: {
                                  value: _vm.newGuideline.standard,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newGuideline, "standard", $$v)
                                  },
                                  expression: "newGuideline.standard",
                                },
                              }),
                              _vm._v(" "),
                              _vm.methodAnalyte != null
                                ? _c("div", { staticClass: "subheading" }, [
                                    !_vm.isAmmonialookuptable(
                                      _vm.newGuideline.standard.ValueType
                                    )
                                      ? _c("div", [
                                          _c("b", [
                                            _vm._v(
                                              "Guideline Value:\n                "
                                            ),
                                          ]),
                                          _vm._v(
                                            _vm._s(
                                              _vm.newGuideline.standard
                                                .StandardValue
                                            )
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isAmmonialookuptable(
                                      _vm.newGuideline.standard.ValueType
                                    )
                                      ? _c("div", [
                                          _c("b", [
                                            _vm._v("Guideline Value: "),
                                          ]),
                                          _vm._v(" "),
                                          _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getGuidelineValueLong(
                                                  _vm.newGuideline.standard
                                                    .StandardValue
                                                )
                                              ),
                                            },
                                          }),
                                        ])
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _vm.selectGuidelines.length &&
                      _vm.analyteData.ApplicableUnitGroupId
                        ? _c(
                            "v-btn",
                            {
                              attrs: { color: "success" },
                              on: {
                                click: function ($event) {
                                  return _vm.addGuidelineStandard()
                                },
                              },
                            },
                            [
                              _c("v-icon", { staticClass: "mr-1" }, [
                                _vm._v("done"),
                              ]),
                              _vm._v(
                                _vm._s(_vm.$t("Button.Save")) + "\n          "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.closeDialog()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800" },
          model: {
            value: _vm.confirmDialog,
            callback: function ($$v) {
              _vm.confirmDialog = $$v
            },
            expression: "confirmDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dense: "", dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v("Unlink from guideline standard"),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          _vm.confirmDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("AnalyteGuidelinesManagement.deleteTitleMsg", {
                        msg: _vm.deleteAnalyteStandardMap
                          .AnalyteNameInGuideline,
                      })
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "delete", dark: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.deleteGuidelineStandard()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("delete_forever"),
                      ]),
                      _vm._v(_vm._s(_vm.$t("Button.unlink")) + "\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function ($event) {
                          _vm.confirmDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-snackbar",
            {
              attrs: {
                color: _vm.snackColor,
                timeout: null,
                top: "",
                "auto-height": "",
              },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  nativeOn: {
                    click: function ($event) {
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }